import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';

import {
  HeaderMarginTop,
  Center,
  Tag,
  Indicator,
} from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { ModeratorForm } from 'apps/channel/moderatorForm/index';

import Box from 'components/Box';
import Button from 'components/Button';
import Heading from 'components/Heading';

import {
  Tabs,
  Tab,
  LinkTabStyled,
  TabsContentCount,
} from 'apps/components/shared';

export const ChannelOverviewIndicator = () => (
  <HeaderMarginTop>
    <Center>
      <Indicator width='200px' height='48px' margin='30px 0px 0px 0px' />
    </Center>
  </HeaderMarginTop>
);

@withNamespaces()
@inject('routerStore')
@observer
export class ChannelOverview extends React.Component {
  apply = () => {
    const { appManager } = this.props;
    const { channel } = appManager;
    modalStore.SetModalComponent(ModeratorForm, {
      channelId: channel.inSpace.id,
    });
  };

  render() {
    const { appManager, channelName, routerStore } = this.props;
    if (appManager.queries.get('channel')?.notFound) {
      return (
        <HeaderMarginTop>
          <Center>
            <Tag size='large' main>
              #{channelName}
            </Tag>
          </Center>
        </HeaderMarginTop>
      );
    }
    const { channel } = appManager;
    const { name } = channel;

    const routeName = routerStore.route.name;
    const projectsCount = appManager.projectsConn.totalCount;
    const storiesCount = appManager.storiesConn.totalCount;
    const threadsCount = appManager.threadsConn.totalCount;
    const collectionsCount = appManager.collectionsConn.totalCount;

    return (
      <HeaderMarginTop
        ref={overview => {
          this.overview = overview;
        }}
      >
        <Box pt={4}>
          <Link name='home.community.topics'>
            <Button
              size='small'
              text='All Topics'
              icon='arrow_left'
              variant='secondary'
            />
          </Link>
          <Heading headingLevel={1} size='xxlarge'>
            #{name}
          </Heading>
        </Box>
        <Tabs noPadding>
          <Tab active={routeName === 'channel'}>
            <LinkTabStyled name='channel' params={{ channel: name }}>
              <Trans>Projects</Trans>
              <TabsContentCount>{projectsCount}</TabsContentCount>
            </LinkTabStyled>
          </Tab>
          <Tab active={routeName === 'channel.stories'}>
            <LinkTabStyled name='channel.stories' params={{ channel: name }}>
              <Trans>Stories</Trans>
              <TabsContentCount>{storiesCount}</TabsContentCount>
            </LinkTabStyled>
          </Tab>
          <Tab active={routeName === 'channel.threads'}>
            <LinkTabStyled name='channel.threads' params={{ channel: name }}>
              <Trans>Threads</Trans>
              <TabsContentCount>{threadsCount}</TabsContentCount>
            </LinkTabStyled>
          </Tab>
          <Tab active={routeName === 'channel.collections'}>
            <LinkTabStyled
              name='channel.collections'
              params={{ channel: name }}
            >
              <Trans>Collections</Trans>
              <TabsContentCount>{collectionsCount}</TabsContentCount>
            </LinkTabStyled>
          </Tab>
        </Tabs>
      </HeaderMarginTop>
    );
  }
}

ChannelOverview.propTypes = {
  appManager: PropTypes.object,
  channelName: PropTypes.string,
};
